module.exports = require("./is.d.ts");